var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.07,
    height: 21.126,
    viewBox: "0 0 21.07 21.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3573",
    "data-name": "Path 3573",
    d: "M73.315,345.6a10.687,10.687,0,0,1-3.961-.913,18.368,18.368,0,0,1-5.19-3.388,22.517,22.517,0,0,1-4.231-4.984,13.886,13.886,0,0,1-1.83-4.467,6.823,6.823,0,0,1,.05-3.341,3.505,3.505,0,0,1,1.557-2.082c.44-.269.89-.522,1.351-.753a1.369,1.369,0,0,1,1.729.556q1.065,1.818,2.287,3.533a1.363,1.363,0,0,1-.3,1.891c-.222.169-.434.35-.665.506a1.876,1.876,0,0,0-.537,2.56,10.616,10.616,0,0,0,.964,1.3,21.7,21.7,0,0,0,3.964,3.74,2.1,2.1,0,0,0,1.747.378,1.633,1.633,0,0,0,.972-.63c.193-.254.4-.5.579-.762a1.417,1.417,0,0,1,1.975-.308c.881.611,1.783,1.192,2.68,1.78.252.165.519.307.777.463a1.386,1.386,0,0,1,.512,1.877c-.222.407-.446.814-.69,1.208a3.763,3.763,0,0,1-2.89,1.773C73.883,345.568,73.6,345.577,73.315,345.6Z",
    transform: "translate(-57.423 -324.974)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/phone-number.f46e712e73f4623fe13660505a396a86.svg";
export { ForwardRef as ReactComponent };